﻿$.fn.dxCtrlTagBoxDestinataireEmail = function custom_dxCtrlTagBoxDestinataireEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrltagboxdestinataireemail dx-ctrl");
        this.createInstance(new cdxCtrlTagBoxDestinataireEmail(this, option));
    }
    return this;
}

window.cdxCtrlTagBoxDestinataireEmail = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    this.isLoaded = false
    var dx = null
    var dxScroll = null
    function mConstruit(funcOk) {
        container.css("height", container.innerHeight() + "px")
        container.empty();

        var obj = option.bddCtrl.getObjet(option.data)
        if (obj.cle() == null) {
            mConstruitDestinataire([]);
            Me.isLoaded = true;
            container.css("height", "")
            if (typeof funcOk != 'undefined') funcOk()
        } else {
            option.bddCtrl.mAjaxCall({ command: "getlstcomdestinataire", id_table_com: obj.mGetTable().id_table, id_com: obj.cle() }, function (data) {
                if (typeof data.lst_com_destinataire == 'undefined') data.lst_com_destinataire = []
                mConstruitDestinataire(data.lst_com_destinataire)
                Me.isLoaded = true;
                container.css("height", "")
                if (typeof funcOk != 'undefined') funcOk()
            })
        }
    }

    this.mReConstruit = function (funcOk) { mConstruit(funcOk); }

    //this.isDirty = function (value) {
    //    return Me.dxTagBoxDestA.isDirty(value) || Me.dxTagBoxDestCC.isDirty(value) || Me.dxTagBoxDestCCI.isDirty(value)
    //}
    var $DivTropDest = null
    this.dxTagBoxDestA = null;
    this.dxTagBoxDestCC = null;
    this.dxTagBoxDestCCI = null;
    function mConstruitDestinataire(lstComDest) {
        var obj = option.bddCtrl.getObjet(option.data)
        var readOnly = false
        if (obj.mGetTable().nom == "com_email_recu" || option.data.date_envoi != null) readOnly = true

        var lstDe = []
        var lstA = []
        var lstCC = []
        var lstCCI = []
        lstComDest.forEach(function (destcom) {
            switch (parseInt(destcom.id_type_destinataire)) {
                case 1: lstA.push(destcom); break;
                case 2: lstCC.push(destcom); break;
                case 3: lstCCI.push(destcom); break;
                case 4: lstDe.push(destcom); break;
            }
        })

        if (obj.mGetTable().nom == "com_email_recu") {
            var dxTagBoxDe = $("<div style='margin:10px 0;'/>").appendTo(container).dxCtrlTagBoxDestinataireCom({
                bddCtrl: option.bddCtrl,
                maxHeight: 200,
                type: "email",
                items: lstDe,
                data: option.data,
                id_type_destinataire: 4,
                funcSave: option.funcSave,
                readOnly: readOnly,
                i: 101,
                onItemClickTag: function (itemData, items, funcEnd,itemEle) {
                    if (itemData.deleteAll) {
                        $("<div/>").appendTo(container).dxCtrlLstBoxDestinataireSelect({
                            bddCtrl: option.bddCtrl,
                            dataSource: items,
                            title: "Liste des expéditeurs",
                            readOnly: readOnly,
                            data: option.data,
                            type: option.type,
                            maxWidthItem: option.maxWidthItem,
                            onDeleteAll: dxTagBoxDe.mDeleteAll,
                            onDeleteItem: dxTagBoxDe.mDeleteItem,
                            onItemClickTag: function (itemData, target, funcEnd, openFiche) { mClickItemTag(itemData, target, funcEnd, openFiche) }
                        })
                    } else { mClickItemTag(itemData, (itemEle ? itemEle : dxTagBoxDe.element()), funcEnd,true) }
                },
            }).dxCtrlTagBoxDestinataireCom("instance")
        }

        var lstIdTable = option.bddCtrl.table.mGetItemFromNom("structures").id_table + "," + option.bddCtrl.table.mGetItemFromNom("structures_contact").id_table + "," + option.bddCtrl.table.mGetItemFromNom("contact").id_table + "," + option.bddCtrl.table.mGetItemFromNom("dossier").id_table + "," + option.bddCtrl.table.mGetItemFromNom("pipeline").id_table
        Me.dxTagBoxDestA = $("<div style='margin:10px 0;'/>").appendTo(container).dxCtrlTagBoxDestinataireCom({
            bddCtrl: option.bddCtrl,
            maxHeight: 200,
            type: ((typeof option.type == 'undefined') ? "email" : option.type),
            lst_id_table: lstIdTable,
            items: lstA,
            withComDest: option.withComDest,
            showOpenList: true,
            getTotalItems: function () {
                return Me.dxTagBoxDestA.option("items").concat(Me.dxTagBoxDestCC.option("items")).concat(Me.dxTagBoxDestCCI.option("items"))
            },
            data: option.data,
            id_type_destinataire: 1,
            funcSave: option.funcSave,
            readOnly: readOnly,
            label: option.labelA,
            hint: option.labelAHint,
            i: 101,
            onChange: option.onChange,
            onChangeSaved: option.onChangeSaved,
            onItemClickTag: function (itemData, items, funcEnd, itemEle) {
                if (itemData.deleteAll) {
                    $("<div/>").appendTo(container).dxCtrlLstBoxDestinataireSelect({
                        bddCtrl: option.bddCtrl,
                        dataSource: items,
                        title: "Liste des destinataires A:",
                        readOnly: readOnly,
                        data: option.data,
                        type: "email",
                        maxWidthItem: option.maxWidthItem,
                        onDeleteAll: Me.dxTagBoxDestA.mDeleteAll,
                        onDeleteItem: Me.dxTagBoxDestA.mDeleteItem,
                        onItemClickTag: function (itemData, target, funcEnd, openFiche) { mClickItemTag(itemData, target, funcEnd, openFiche) }
                    })
                } else { mClickItemTag(itemData, (itemEle ? itemEle : Me.dxTagBoxDestA.element()), funcEnd, itemEle) }
            },
            ajoutTemplate: function (contentElement) {
                if (!readOnly) {
                    var $TableCCCCI = $("<table/>").appendTo(contentElement)
                    var $Tr = $("<tr/>").appendTo($TableCCCCI)
                    if (!option.showCC) {
                        var $TdCC = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
                        var $AAfficheCC = $("<a href='javascript:void(0)' style='display:inline-block;padding-right:10px;' title='Afficher CC:' tabindex='-1'>CC:</a>").appendTo($TdCC)
                        $AAfficheCC.on("click", function (e) {
                            Me.dxTagBoxDestCC.element().show()
                            $TdCC.hide()
                        })
                        if (lstCC.length > 0) $TdCC.hide()
                    }

                    if (!option.showCCI) {
                        var $TdCCI = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
                        var $AAfficheCCI = $("<a href='javascript:void(0)' style='display:inline-block;padding-right:10px;' title='Afficher CCI:' tabindex='-1'>CCI:</a>").appendTo($TdCCI)
                        $AAfficheCCI.on("click", function (e) {
                            Me.dxTagBoxDestCCI.element().show()
                            $TdCCI.hide()
                        })
                        if (lstCCI.length > 0) $TdCCI.hide()
                    }

                    //var $GereDestinataire = $("<a href='javascript:void(0)' style='display:inline-block'>Gestion</a>").appendTo(contentElement)
                    //$GereDestinataire.attr("title", "Gérer/nettoyer<br/>les destinataires<br/>de votre email<br/><i>(Désinscriptions, bounce,<br/>sans adresse, doublon...)</i>")
                    //$GereDestinataire.on("click", function (e) {
                    //    option.onDemandeGestion()
                    //})
                }
            }
        }).dxCtrlTagBoxDestinataireCom("instance")
        Me.dxTagBoxDestCC = $("<div style='margin:10px 0;display:" + ((lstCC.length == 0 && !option.showCC) ? "none" : "") + ";'/>").appendTo(container).dxCtrlTagBoxDestinataireCom({
            bddCtrl: option.bddCtrl,
            maxHeight: 200,
            type: ((typeof option.type == 'undefined') ? "email" : option.type),
            items: lstCC,
            withComDest: option.withComDest,
            lst_id_table: lstIdTable,
            getTotalItems: function () {
                return Me.dxTagBoxDestA.option("items").concat(Me.dxTagBoxDestCC.option("items")).concat(Me.dxTagBoxDestCCI.option("items"))
            },
            data: option.data,
            id_type_destinataire: 2,
            funcSave: option.funcSave,
            readOnly: readOnly,
            label: option.labelCC,
            hint: option.labelCCHint,
            showOpenList: true,
            i: 3,
            onChange: option.onChange,
            onChangeSaved: option.onChangeSaved,
            onItemClickTag: function (itemData, items, funcEnd, itemEle) {
                if (itemData.deleteAll) {
                    $("<div/>").appendTo(container).dxCtrlLstBoxDestinataireSelect({
                        bddCtrl: option.bddCtrl,
                        dataSource: items,
                        title: "Liste des destinataires CC:",
                        readOnly: readOnly,
                        data: option.data,
                        type: "email",
                        maxWidthItem: option.maxWidthItem,
                        onDeleteAll: Me.dxTagBoxDestCC.mDeleteAll,
                        onDeleteItem: Me.dxTagBoxDestCC.mDeleteItem,
                        onItemClickTag: function (itemData, target, funcEnd, openFiche) { mClickItemTag(itemData, target, funcEnd, openFiche) }
                    })
                } else { mClickItemTag(itemData, (itemEle ? itemEle : Me.dxTagBoxDestCC.element()), funcEnd, itemEle) }
            }
        }).dxCtrlTagBoxDestinataireCom("instance")
        Me.dxTagBoxDestCCI = $("<div style='margin:10px 0;display:" + ((lstCCI.length == 0 && !option.showCCI) ? "none" : "") + ";'/>").appendTo(container).dxCtrlTagBoxDestinataireCom({
            bddCtrl: option.bddCtrl,
            maxHeight: 200,
            type: ((typeof option.type == 'undefined') ? "email" : option.type),
            items: lstCCI,
            withComDest: option.withComDest,
            lst_id_table: lstIdTable,
            getTotalItems: function () {
                return Me.dxTagBoxDestA.option("items").concat(Me.dxTagBoxDestCC.option("items")).concat(Me.dxTagBoxDestCCI.option("items"))
            },
            data: option.data,
            id_type_destinataire: 3,
            funcSave: option.funcSave,
            readOnly: readOnly,
            label: option.labelCCI,
            hint: option.labelCCIHint,
            showOpenList: true,
            i: 3,
            onChange: option.onChange,
            onChangeSaved: option.onChangeSaved,
            onItemClickTag: function (itemData, items, funcEnd, itemEle) {
                if (itemData.deleteAll) {
                    $("<div/>").appendTo(container).dxCtrlLstBoxDestinataireSelect({
                        bddCtrl: option.bddCtrl,
                        dataSource: items,
                        title: "Liste des destinataires CCI:",
                        readOnly: readOnly,
                        data: option.data,
                        type: "email",
                        maxWidthItem: option.maxWidthItem,
                        onDeleteAll: Me.dxTagBoxDestCCI.mDeleteAll,
                        onDeleteItem: Me.dxTagBoxDestCCI.mDeleteItem,
                        onItemClickTag: function (itemData, target, funcEnd, openFiche) { mClickItemTag(itemData, target, funcEnd, openFiche) }
                    })
                } else { mClickItemTag(itemData, (itemEle ? itemEle : Me.dxTagBoxDestCCI.element()), funcEnd, itemEle) }
            }
        }).dxCtrlTagBoxDestinataireCom("instance")

        if (typeof option.onContentReady != 'undefined') option.onContentReady()
    }

    function mClickItemTag(itemData, target, funcEnd, openFiche) {
        if (itemData.id_table_destinataire == null) {
            var dataCompteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) { return o.adresse_email == itemData.adresse_email })[0]
            //if (typeof dataCompteEmail == 'undefined') {
            option.bddCtrl.getObjet("com_destinataire").objetMetier.mCreateContactFromComDest(target, itemData, funcEnd, openFiche)
            //    //mCreateContact(Me.dxTagBoxDestCCI.element(), itemData)
            //} else {
            //    option.bddCtrl.getObjet(dataCompteEmail).mShowPopup()
            //}
        } else {
            var objDest = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(itemData.id_table_destinataire).nom, itemData.id_destinataire)
            if (typeof objDest.data != 'undefined') objDest.mShowPopup()
        }
    }

    this.mGetNbDest_A_CC_CCI = function () {
        if (Me.dxTagBoxDestA == null) { return 0 }
        else { return Me.dxTagBoxDestA.option("items").length + Me.dxTagBoxDestCC.option("items").length + Me.dxTagBoxDestCCI.option("items").length }
    }

    this.mGetLstDestinataireSansEmail = function () {
        var lst = Me.dxTagBoxDestA.option("items").filter(function (dest) { return dest.adresse_email.length == 0 })
        var lst = lst.concat(Me.dxTagBoxDestCC.option("items").filter(function (dest) { return dest.adresse_email.length == 0 }))
        var lst = lst.concat(Me.dxTagBoxDestCCI.option("items").filter(function (dest) { return dest.adresse_email.length == 0 }))
        return lst
    }

    this.element = function () { return container }

    //this.dispose = function () {
    //    if (this.dxTagBoxDestA) this.dxTagBoxDestA.dispose()
    //    if (this.dxTagBoxDestCC) this.dxTagBoxDestCC.dispose()
    //    if (this.dxTagBoxDestCCI) this.dxTagBoxDestCCI.dispose()
    //}

    mConstruit();
}